import React from "react";
import ReactInterval from "react-interval";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroller";
import ReactSimpleRange from "react-simple-range";

import AreaLimitMarker from "../../static/images/gps/AreaLimitMarker.png";

import { moment, getDetailGPSStatus } from "../common/common";
import { setInterval, setTimeout } from "timers";
import { getAddressFromLatLng, getAddressFromLatLngHere } from "../../model/common";
import {
	getOwnerCars,
	getCarsLocation,
	getDetailsTripGPS,
	getCarLocationHistory,
	updateGPSDeviceConfig,
} from "../../model/car";

import { commonErr } from "../common/errors";
import { LoadingInline, LoadingInlineSmall, LoadingPage } from "../common/loading";
import { MessagePage } from "../common/messagebox";

import Header from "../components/header";

import {
	IcContract,
	IcRefresh,
	IcSpeed,
	IcSpeedRed,
	IcHigher,
	IcBatteryGreen,
	IcBatteryYellow,
	IcBatteryRed,
	IcWarning,
	IcGPSFocus,
	IcGPSDirect,
	IcGPSSetting,
	IcBCrLocation,
	IcLocation18,
	IcSpeed18,
	IcMap,
	IcGarbage,
	IcGPSPlay,
	IcGPSPause,
	IcGPSReturn,
	IcGPSTimeX1,
	IcGPSTimeX2,
	IcGPSTimeX3,
	IcGPSTimeX4,
	IcGPSTimeX8,
} from "../common/svg";

const MIN_TIMER = 60000;
const MIN_MAP_RADIUS = 2000;
const MAX_LAT_LNG_PER_TIME = 2;

function formatTimeLabel(ts) {
	const deltaTime = moment().valueOf() - ts;
	if (deltaTime < 3600000) {
		return {
			label: "Vừa cập nhật",
			class: "green-dot",
		};
	} else {
		return {
			label: moment(ts).fromNow(),
			class: "red-dot",
		};
	}
}

var CarPopup;
/** Defines the CarPopup class. */
function defineCarPopupClass() {
	/**
	 * A customized popup on the map.
	 * @param {!google.maps.LatLng} position
	 * @param {!Element} content
	 * @constructor
	 * @extends {google.maps.OverlayView}
	 */
	CarPopup = function (car, position, type, ts, speed) {
		// this.id = car.id;
		// this.name = car.name;
		this.position = position;

		var contentBox = document.createElement("div");
		contentBox.classList.add("popup-bubble-anchor", "car-gps");
		const content = document.createElement("div");
		content.classList.add("popup-bubble-content", "popup-car-gps");
		const contentGPSBox = document.createElement("div");
		contentGPSBox.classList.add("gps-box");
		const contentBoxText = document.createElement("div");
		contentBoxText.classList.add("box-text");
		let html = "";
		if (car) {
			html += '<span class="license-plate">' + car.licensePlate + "</span>";
		}
		if (ts) {
			const tsLabel = formatTimeLabel(ts);
			html += '<span class="time"> <span class="status ' + tsLabel.class + '"> </span>' + tsLabel.label + "</span>";
		}
		if (speed || speed == 0) {
			html +=
				'<span class="speed"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.92406 2.2549C3.09527 3.00575 0.737946 5.52023 0.126788 8.4014C-0.135136 9.69356 0.0220186 11.5794 0.476022 12.8367C0.982409 14.1812 1.17449 14.3034 2.01265 13.8669C3.13019 13.2907 3.40958 13.0287 3.16512 12.7843C2.9905 12.6097 2.79842 12.6446 2.23965 12.9589L1.54118 13.3605L1.20941 12.5922C1.01733 12.1731 0.825254 11.5096 0.755408 11.108L0.633176 10.3746L1.4888 10.3222C2.09996 10.2873 2.32696 10.2 2.32696 10.0079C2.32696 9.8158 2.09996 9.72849 1.50626 9.69356C0.982409 9.65864 0.6681 9.55387 0.6681 9.43164C0.6681 9.15225 1.17449 7.21401 1.29672 7.02193C1.3491 6.93462 1.69834 7.02193 2.08249 7.21401C2.46665 7.42355 2.85081 7.52832 2.93811 7.47593C3.28735 7.2664 3.09527 6.91716 2.50157 6.63778C2.1698 6.48062 1.89042 6.25362 1.89042 6.14885C1.89042 5.86946 2.88573 4.66461 3.46196 4.24553L3.96835 3.8963L4.35251 4.59476C4.75413 5.31069 5.20813 5.52023 5.20813 4.97892C5.20813 4.82176 5.05097 4.42015 4.8589 4.1233C4.52712 3.56453 4.52712 3.54706 4.84143 3.37245C5.20813 3.18037 7.07653 2.67398 7.42576 2.67398C7.54799 2.67398 7.65276 2.98829 7.68768 3.49468C7.72261 4.10584 7.80992 4.33284 8.00199 4.33284C8.19407 4.33284 8.28138 4.10584 8.3163 3.49468C8.35123 2.98829 8.456 2.67398 8.57823 2.67398C8.85761 2.67398 10.7959 3.18037 10.9879 3.3026C11.0752 3.35499 10.9879 3.70422 10.7959 4.08837C10.5863 4.47253 10.4815 4.85669 10.5339 4.944C10.7435 5.29323 11.0927 5.10115 11.3721 4.50745C11.5292 4.17568 11.7562 3.8963 11.8959 3.8963C12.1928 3.8963 13.3103 4.83923 13.7643 5.46785L14.1136 5.97423L13.4151 6.35839C12.6992 6.76001 12.4896 7.21401 13.0309 7.21401C13.1881 7.21401 13.5897 7.05686 13.8866 6.86478C14.4453 6.53301 14.4628 6.53301 14.6374 6.84732C14.8295 7.21401 15.3359 9.08241 15.3359 9.43164C15.3359 9.55387 15.0216 9.65864 14.5152 9.69356C13.904 9.72849 13.677 9.8158 13.677 10.0079C13.677 10.2 13.904 10.2873 14.5152 10.3222L15.3708 10.3746L15.2486 11.108C15.1787 11.5096 14.9867 12.1731 14.7946 12.5922L14.4628 13.3605L13.7643 12.9589C13.2056 12.6446 13.0135 12.6097 12.8389 12.7843C12.5944 13.0287 12.8738 13.2907 13.9913 13.8669C14.8295 14.3034 15.0041 14.1812 15.528 12.8367C16.2788 10.8286 16.1217 8.22679 15.1438 6.306C14.62 5.29323 13.0135 3.63437 11.9309 3.02321C10.1847 2.0279 7.87976 1.73105 5.92406 2.2549Z" fill="white"></path><path d="M10.3591 8.19174C9.06696 8.96005 8.68281 9.11721 8.2288 9.0299C7.60018 8.90767 6.9541 9.41406 6.9541 10.0078C6.9541 10.4618 7.5478 11.0555 8.0018 11.0555C8.43834 11.0555 9.0495 10.4618 9.0495 10.0427C9.06696 9.8506 9.6432 9.41406 10.7258 8.78544C11.7735 8.19174 12.3672 7.73774 12.3323 7.58058C12.245 7.14404 11.9656 7.23135 10.3591 8.19174ZM8.28119 9.8506C8.4558 10.1474 8.05419 10.4792 7.80972 10.2348C7.60018 10.0252 7.73988 9.65852 8.0018 9.65852C8.08911 9.65852 8.21134 9.74583 8.28119 9.8506Z" fill="white"></path><path d="M5.64481 12.9938C5.38288 13.4129 5.92419 13.5177 8.1069 13.4653C9.9753 13.4129 10.3595 13.3605 10.3595 13.151C10.3595 12.9414 9.95783 12.889 8.05451 12.8366C6.50043 12.8017 5.71465 12.8541 5.64481 12.9938Z" fill="white"></path></svg>' +
				speed.toFixed(1) +
				" km/h</span>";
		}

		contentBoxText.innerHTML = html;
		contentBox.appendChild(content);
		content.appendChild(contentGPSBox);
		contentGPSBox.appendChild(contentBoxText);

		this.anchor = document.createElement("div");
		this.anchor.classList.add("popup-tip-anchor");
		this.anchor.appendChild(contentBox);
	};

	// NOTE: google.maps.OverlayView is only defined once the Maps API has
	// loaded. That is why CarPopup is defined inside initMap().
	CarPopup.prototype = Object.create(window.google.maps.OverlayView.prototype);

	/** Called when the popup is added to the map. */
	CarPopup.prototype.onAdd = function () {
		this.getPanes().floatPane.appendChild(this.anchor);
	};

	/** Called when the popup is removed from the map. */
	CarPopup.prototype.onRemove = function () {
		if (this.anchor.parentElement) {
			this.anchor.parentElement.removeChild(this.anchor);
		}
	};

	/** Called when the popup needs to draw itself. */
	CarPopup.prototype.draw = function () {
		var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
		// Hide the popup when it is far out of view.
		var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? "block" : "none";

		if (display === "block") {
			this.anchor.style.left = divPosition.x - 52 + "px";
			this.anchor.style.top = divPosition.y - 0 + "px";
		}
		if (this.anchor.style.display !== display) {
			this.anchor.style.display = display;
		}
	};

	/** Stops clicks/drags from bubbling up to the map. */
	CarPopup.prototype.stopEventPropagation = function () {
		var anchor = this.anchor;
		anchor.style.cursor = "auto";

		["click", "dblclick", "contextmenu", "wheel", "mousedown", "touchstart", "pointerdown"].forEach(function (event) {
			anchor.addEventListener(
				event,
				function (e) {
					e.stopPropagation();
				},
				{
					passive: true,
				}
			);
		});
	};
	CarPopup.prototype.hideBoxTime = function () {
		var anchor = this.anchor;
	};
}

class CarMapLocation extends React.Component {
	pMarkers = [];
	pPopups = [];
	pPastPointMarkers = [];
	pAreaLimitMarkers = [];
	pWrapperArea = [];

	componentDidMount() {
		defineCarPopupClass();
		this.initMap(this.refs, this.props.cars, this.props.markers, this.props.pastPointMarkers);
	}

	componentWillUpdate(props, state) {
		const oCars = this.props.cars;
		let {
			cars,
			markers,
			isUpdateBounds,
			filterValue,
			pastPointMarkers,
			areaLimit,
			isSettingAreaLimit,
			getAreaLimitPost,
			enableAreaLimit,
			addPointMode,
			startMoveCar,
			endMoveCar,
			handlePlayCar,
			handlePauseCar,
			onPlayerTrackingChange,
		} = props;

		if (enableAreaLimit) {
			for (let areaLimitMarker of this.pAreaLimitMarkers) {
				areaLimitMarker.setMap(null);
			}
			this.pAreaLimitMarkers = [];

			//rename property LON ---> LNG (Format of Google Map API)
			let result = areaLimit.map(({ lon, ...rest }) => ({ ...rest, lng: lon }));

			//insert area Marker
			if (addPointMode && isSettingAreaLimit && result.length < 10) {
				window.google.maps.event.addListener(this.map, "click", (e) => {
					if (result.length > 0) {
						const map1 = result.map((x) => x);
						const map2 = result.map((x) => x);
						const shift = map1.shift();
						map1.push(shift);
						const sum = map1.map((geo, idx) => {
							return { lat: (geo.lat + map2[idx].lat) / 2, lng: (geo.lng + map2[idx].lng) / 2 };
						});
						const diffArr = sum.map((x) =>
							Math.sqrt(
								Math.pow(x.lat - parseFloat(e.latLng.lat().toFixed(6)), 2) +
									Math.pow(x.lng - parseFloat(e.latLng.lng().toFixed(6)), 2)
							)
						);
						const minNumber = Math.min(...diffArr);
						const index = diffArr.findIndex((x) => x === minNumber);

						result.splice(index + 1, 0, {
							lat: parseFloat(e.latLng.lat().toFixed(6)),
							lng: parseFloat(e.latLng.lng().toFixed(6)),
						});
						const areaLimitPost = result.map(({ lng, ...rest }) => ({ ...rest, lon: lng }));
						getAreaLimitPost(areaLimitPost);
					} else {
						result = [{ lat: parseFloat(e.latLng.lat().toFixed(6)), lng: parseFloat(e.latLng.lng().toFixed(6)) }];
						const areaLimitPost = result.map(({ lng, ...rest }) => ({ ...rest, lon: lng }));
						getAreaLimitPost(areaLimitPost);
					}
				});
			} else {
				window.google.maps.event.clearListeners(this.map, "click");
			}

			//SHOW AREA LIMIT MARKERS
			for (let i = 0; i < result.length; ++i) {
				let areaMarker = new window.google.maps.Marker({
					position: new window.google.maps.LatLng(result[i].lat, result[i].lng),
					icon: AreaLimitMarker,
					draggable: isSettingAreaLimit ? true : false,
				});
				if (isSettingAreaLimit) {
					areaMarker.setMap(this.map);
					this.pAreaLimitMarkers.push(areaMarker);
				}

				if (isSettingAreaLimit && !addPointMode) {
					if (result.length > 3) {
						window.google.maps.event.addListener(areaMarker, "click", () => {
							result.splice(i, 1);
							const areaLimitPost = result.map(({ lng, ...rest }) => ({ ...rest, lon: lng }));
							getAreaLimitPost(areaLimitPost);
						});
					}
				}

				window.google.maps.event.addListener(areaMarker, "drag", () => {
					result[i] = {
						lat: parseFloat(areaMarker.getPosition().lat().toFixed(6)),
						lng: parseFloat(areaMarker.getPosition().lng().toFixed(6)),
					};

					for (let wrapperMarker of this.pWrapperArea) {
						wrapperMarker.setMap(null);
					}
					this.pWrapperArea = [];

					const wrapperArea = new window.google.maps.Polygon({
						paths: result,
						strokeColor: "#00a550",
						strokeWeight: 2,
						fillColor: "#00a550",
						fillOpacity: 0.1,
						map: this.map,
					});

					wrapperArea.setMap(this.map);
					this.pWrapperArea.push(wrapperArea);
				});

				window.google.maps.event.addListener(areaMarker, "dragend", () => {
					result[i] = {
						lat: parseFloat(areaMarker.getPosition().lat().toFixed(6)),
						lng: parseFloat(areaMarker.getPosition().lng().toFixed(6)),
					};
					const areaLimitPost = result.map(({ lng, ...rest }) => ({ ...rest, lon: lng }));
					getAreaLimitPost(areaLimitPost);
				});
			}

			for (let wrapperMarker of this.pWrapperArea) {
				wrapperMarker.setMap(null);
			}
			this.pWrapperArea = [];

			const wrapperArea = new window.google.maps.Polygon({
				paths: result,
				strokeColor: "#00a550",
				strokeWeight: 2,
				fillColor: "#00a550",
				fillOpacity: 0.1,
				map: this.map,
			});

			wrapperArea.setMap(this.map);
			this.pWrapperArea.push(wrapperArea);
		} else {
			for (let areaLimitMarker of this.pAreaLimitMarkers) {
				areaLimitMarker.setMap(null);
			}
			this.pAreaLimitMarkers = [];
			for (let wrapperMarker of this.pWrapperArea) {
				wrapperMarker.setMap(null);
			}
			this.pWrapperArea = [];
		}

		// UPDATE POSITION, ICON, CARPOPUP CURRENT
		for (let i = 0; i < cars.length; ++i) {
			const carId = cars[i].id;
			const marker = markers[carId];
			const pPopup = this.pPopups[carId];
			pPopup.setMap(null);
			if (this.pMarkers[carId].map === null) {
				this.pMarkers[carId].setMap(this.map);
			}
			this.pMarkers[carId].setPosition(new window.google.maps.LatLng(marker.lat, marker.lng));
			this.pMarkers[carId].setIcon(this.buildIcon(marker.lat, marker.lng, marker.preLat, marker.preLng));

			const newPPopup = new CarPopup(
				marker.car,
				new window.google.maps.LatLng(marker.lat, marker.lng),
				1,
				filterValue.time <= 3600 ? marker.activeTime : null,
				marker.speed
			);
			newPPopup.setMap(this.map);
			this.pPopups[carId] = newPPopup;

		if (filterValue.car === "") {
			window.google.maps.event.addListener(this.pMarkers[carId], "click", () => {
				this.props.filterWhenClickIcon(carId);
				this.props.getCarsLocation([marker.car], true);
				this.props.getDetailsTripGPS(carId, 0);
				this.props.getAllSetting(carId);
			});
		} else {
			window.google.maps.event.clearListeners(this.pMarkers[carId], "click");
		}
		}
		// UPDATE PAST POINT
		// Remove all prev pastPointMarkers
		for (let pastPointMarker of this.pPastPointMarkers) {
			pastPointMarker.setMap(null);
		}
		this.pPastPointMarkers = [];
		// Draw all current pastPointMarkers
		for (let pastPointMarker of pastPointMarkers) {
			if (!isSettingAreaLimit) {
				// Draw line between 2 pointMarker
				var newPastPointMarker = new window.google.maps.Polyline({
					path: [
						new window.google.maps.LatLng(pastPointMarker.lat, pastPointMarker.lng),
						new window.google.maps.LatLng(pastPointMarker.preLat, pastPointMarker.preLng),
					],
					strokeColor: "#00a550",
					strokeOpacity: 1.0,
					strokeWeight: 3,
					map: this.map,
				});
				this.pPastPointMarkers.push(newPastPointMarker);
			}
		}
		// FILTER CAR
		if (filterValue.car !== "") {
			//  Hide all another cars
			for (let i = 0; i < oCars.length; ++i) {
				const oCarId = oCars[i].id;
				if (oCarId !== filterValue.car) {
					const pMarker = this.pMarkers[oCarId];
					pMarker.setMap(null);
					const pPopup = this.pPopups[oCarId];
					pPopup.setMap(null);
				}
			}
			// MOVE CAR
			if (this.props.isMoveCar) {
				this.pPopups[cars[0].id].setMap(null);
			}
			if (props.isMoveCar !== this.props.isMoveCar && props.isMoveCar == true) {
				let j = props.pastPointCount;
				this.setIntervalCar(pastPointMarkers, markers, this.map, cars, j, this.props.timeSpeed, props);
			}

			//Pause
			if (this.props.isMoveCar && !this.props.isPlay) {
				for (let i = 0; i < this.props.idInterval.length; ++i) {
					clearInterval(this.props.idInterval[i]);
				}
			}
			if (props.isPlay !== this.props.isPlay && props.isPlay == true) {
				let j = props.pastPointCount;
				this.clearBeforeSetIntervalCar(pastPointMarkers, markers, this.map, cars, j, props.timeSpeed, props);
			}

			if (props.timeSpeed !== this.props.timeSpeed) {
				let j = props.pastPointCount;
				if (this.props.isMoveCar && this.props.isPlay) {
					this.clearBeforeSetIntervalCar(pastPointMarkers, markers, this.map, cars, j, props.timeSpeed, props);
				}
			}
			if (props.pastPointCount !== 0 && props.pastPointCount > this.props.pastPointCount + 1) {
				let j = props.pastPointCount;
				if (this.props.isMoveCar && this.props.isPlay) {
					this.clearBeforeSetIntervalCar(pastPointMarkers, markers, this.map, cars, j, props.timeSpeed, props);
				}
			}
			if (props.pastPointCount !== 0 && props.pastPointCount < this.props.pastPointCount) {
				let j = props.pastPointCount;
				if (this.props.isMoveCar && this.props.isPlay) {
					this.clearBeforeSetIntervalCar(pastPointMarkers, markers, this.map, cars, j, props.timeSpeed, props);
				}
			}
		}

		if (isUpdateBounds) {
			this.fitBounds(this.map, cars, markers, pastPointMarkers);
		}
	}

	setIntervalCar = (pastPointMarkers, markers, map, cars, j, timeSpeed, props) => {
		const interval = setInterval(() => {
			this.props.getIdInterval(interval._id);
			this.props.onPlayerTrackingChange(j);
			this.moveCar(pastPointMarkers, markers, map, cars, j, timeSpeed, props);

			if (j > pastPointMarkers.length - 2) {
				this.props.turnOffBounds();
				this.props.endMoveCar();
				this.props.handlePauseCar();
				for (let i = 0; i < this.props.pPopupPastArr.length; ++i) {
					this.props.pPopupPastArr[i].setMap(null);
				}
				clearInterval(interval._id);
			}
			j++;
		}, timeSpeed);
	};

	clearBeforeSetIntervalCar = (pastPointMarkers, markers, map, cars, j, timeSpeed, props) => {
		for (let i = 0; i < this.props.idInterval.length; ++i) {
			clearInterval(this.props.idInterval[i]);
		}
		const interval = setInterval(() => {
			this.props.getIdInterval(interval._id);
			this.props.onPlayerTrackingChange(j);
			this.moveCar(pastPointMarkers, markers, map, cars, j, timeSpeed, props);

			if (j > pastPointMarkers.length - 2) {
				this.props.turnOffBounds();
				this.props.endMoveCar();
				this.props.handlePauseCar();
				for (let i = 0; i < this.props.pPopupPastArr.length; ++i) {
					this.props.pPopupPastArr[i].setMap(null);
				}
				clearInterval(interval._id);
			}
			j++;
		}, timeSpeed);
	};

	moveCar = (pastPointMarkers, markers, map, cars, j, timeSpeed, props) => {
		const pastPointMarker = [...pastPointMarkers, markers[cars[0].id]][j];
		const pPopupPast = new CarPopup(
			markers[cars[0].id].car,
			new window.google.maps.LatLng(pastPointMarker.lat, pastPointMarker.lng),
			1,
			null,
			pastPointMarker.speed
		);
		this.props.setMarkerInPastPointMarker(pastPointMarker, cars);

		this.props.pushPopupPastArr(pPopupPast);
		for (let i = 0; i < this.props.pPopupPastArr.length; ++i) {
			this.props.pPopupPastArr[i].setMap(null);
		}

		pPopupPast.setMap(map);

		this.pMarkers[cars[0].id].setPosition(new window.google.maps.LatLng(pastPointMarker.lat, pastPointMarker.lng));
		this.pMarkers[cars[0].id].setIcon(
			this.buildIcon(pastPointMarker.lat, pastPointMarker.lng, pastPointMarker.preLat, pastPointMarker.preLng)
		);
	};

	buildIcon = (lat, lng, preLat, preLng) => {
		const pre = new window.google.maps.LatLng(preLat, preLng);
		const cur = new window.google.maps.LatLng(lat, lng);
		var rotation = 0;
		if (preLat && preLng) {
			rotation = window.google.maps.geometry.spherical.computeHeading(pre, cur) - 90;
		}
		var scale = 0.5;

		return {
			path: "M63.656,43.791c-0.695-4.486-1.998-7.645-3.874-9.387c-1.422-1.271-3.185-0.922-3.22-0.913 c-0.375,0.005-37.69,0.501-40.094,0.572C10.641,34.235,7.685,39.597,7.685,50c0,10.402,2.956,15.765,8.784,15.937   c2.403,0.07,39.719,0.565,40.054,0.565c0.026,0.006,0.275,0.056,0.651,0.056c0.659,0,1.704-0.152,2.61-0.966   c1.874-1.738,3.177-4.896,3.872-9.384c0.512-3.311,0.486-6.156,0.485-6.208C64.143,49.948,64.168,47.103,63.656,43.791z    M16.195,50.755c-0.729,0-1.321-0.338-1.321-0.755s0.592-0.756,1.321-0.756s1.322,0.339,1.322,0.756S16.925,50.755,16.195,50.755z M94.822,33.357l-0.387-0.482c-2.192-2.729-3.924-4.886-9.569-4.886H64.785c-0.266,0-1.062,0.01-1.502,0.016   c0.591-1.85,0.316-3.496-0.755-4.444c-0.933-0.825-2.263-0.925-3.558-0.265c-0.292,0.148-0.242,0.663,0.113,2.63   c0.135,0.743,0.314,1.736,0.291,2.063c-3.052,0-7.566,0.033-12.343,0.066c-11.478,0.082-25.762,0.184-30.114-0.066   c-5.299-0.305-8.856,0.534-10.885,2.563C4.381,32.205,1.61,36.926,1.61,50c0,13.072,2.771,17.795,4.423,19.447   c2.029,2.028,5.589,2.868,10.885,2.562c4.353-0.25,18.637-0.148,30.114-0.067c4.776,0.035,9.291,0.067,12.343,0.067   c0.023,0.326-0.156,1.321-0.291,2.064c-0.355,1.966-0.405,2.481-0.113,2.629c0.566,0.29,1.144,0.434,1.688,0.434   c0.697,0,1.347-0.235,1.869-0.697c1.071-0.949,1.346-2.595,0.755-4.445c0.44,0.007,1.236,0.016,1.502,0.016h20.081   c5.646,0,7.377-2.156,9.569-4.886l0.387-0.481c3.584-4.425,3.766-14.64,3.766-16.643S98.406,37.782,94.822,33.357z M89.902,30.071   c0,0,1.478,0.938,2.575,2.312s1.927,2.88,1.927,2.88c-1.225,0.997-3.063,0.884-4.465-0.841   C88.537,32.697,88.678,31.066,89.902,30.071z M96.228,41.042c0.042,0.272,0.427,3.491,0.439,3.662   c-0.019-0.205-12.272-2.258-17.295-2.876c0.011,0.078-0.429-2.706-0.847-4.127C78.525,37.701,90.791,39.231,96.228,41.042z    M75.119,66.329c-1.944,3.381-5.636,3.466-8.604,3.532l-0.225,0.005c-0.4,0.01-0.965,0.014-1.663,0.014   c-4.574,0-14.829-0.191-21.433-0.442c-7.387-0.281-24.802-0.791-28.287-0.714c-3.361,0.07-5.387,0.111-7.834-3.818   C4.681,61.06,3.897,52.513,3.897,50s0.783-11.06,3.177-14.906c2.447-3.93,4.477-3.887,7.834-3.817   c3.48,0.072,20.9-0.434,28.287-0.715c7.609-0.289,20.064-0.499,23.096-0.428l0.225,0.004c2.968,0.067,6.659,0.15,8.604,3.533   c2.12,3.692,3.387,9.797,3.387,16.329C78.506,56.531,77.239,62.636,75.119,66.329z M92.478,67.616   c-1.098,1.374-2.575,2.312-2.575,2.312c-1.225-0.996-1.365-2.625,0.037-4.351c1.401-1.727,3.24-1.838,4.465-0.843   C94.404,64.734,93.575,66.241,92.478,67.616z M96.228,58.956c-5.437,1.812-17.702,3.342-17.702,3.342   c0.418-1.42,0.857-4.205,0.847-4.127c5.022-0.619,17.276-2.67,17.295-2.875C96.654,55.466,96.27,58.686,96.228,58.956z",
			fillColor: "#000",
			fillOpacity: 1,
			strokeWeight: 0,
			scale: scale,
			anchor: new window.google.maps.Point(29, 50),
			rotation: rotation,
		};
	};

	fitBounds = (map, cars, markers, pastPointMarkers) => {
		var bounds = new window.google.maps.LatLngBounds();

		if (pastPointMarkers.length !== 0) {
			for (var i = 0; i < pastPointMarkers.length; ++i) {
				const pastPointMarker = pastPointMarkers[i];
				bounds.extend(new window.google.maps.LatLng(pastPointMarker.lat, pastPointMarker.lng));
			}
		} else {
			for (var i = 0; i < cars.length; ++i) {
				const marker = markers[cars[i].id];
				bounds.extend(new window.google.maps.LatLng(marker.lat, marker.lng));
			}
		}

		const ne = bounds.getNorthEast();
		const center = bounds.getCenter();
		const mapRadius = window.google.maps.geometry.spherical.computeDistanceBetween(ne, center);

		if (mapRadius < MIN_MAP_RADIUS && cars.length === 1) {
			const circle = new window.google.maps.Circle({
				center: center,
				radius: MIN_MAP_RADIUS,
			});
			map.fitBounds(circle.getBounds());
		} else {
			map.fitBounds(bounds);
		}
	};

	initMap = (refs, cars, markers, pastPointMarkers) => {
		const map = (this.map = new window.google.maps.Map(refs.map, {
			mapTypeControl: false,
			scrollwheel: true,
			clickableIcons: false,
			streetViewControl: false,
			zoomControl: true,
			zoomControlOptions: {
				style: window.google.maps.ZoomControlStyle.SMALL,
			},
			mapTypeId: window.google.maps.MapTypeId.ROADMAP,
			fullscreenControl: false,
		}));

		for (var i = 0; i < cars.length; ++i) {
			const marker = markers[cars[i].id];
			var pMarker = new window.google.maps.Marker({
				position: new window.google.maps.LatLng(marker.lat, marker.lng),
				icon: this.buildIcon(marker.lat, marker.lng, marker.preLat, marker.preLng),
				map: map,
				zIndex: 99999,
			});

			const pPopup = new CarPopup(
				marker.car,
				new window.google.maps.LatLng(marker.lat, marker.lng),
				1,
				marker.activeTime,
				marker.speed
			);
			pPopup.setMap(map);

			this.pMarkers[marker.car.id] = pMarker;
			this.pPopups[marker.car.id] = pPopup;

			window.google.maps.event.addListener(pMarker, "click", () => {
				this.props.filterWhenClickIcon(marker.car.id);
				this.props.getCarsLocation([marker.car], true);
				this.props.getDetailsTripGPS(marker.car.id, 0);
				this.props.getAllSetting(marker.car.id);
			});
		}

		this.fitBounds(map, cars, markers, pastPointMarkers);
	};

	render() {
		const {
			turnOnBounds,
			turnOffBounds,
			addPointMode,
			timeSpeed,
			filterValue,
			pastPointMarkers,
			isSettingAreaLimit,
			isPlay,
			startMoveCar,
			endMoveCar,
			handlePlayCar,
			handlePauseCar,
			pastPointCount,
			onPlayerTrackingDraggableChange,
			returnMoveCar,
			changeTimeSpeed,
		} = this.props;
		const isOneCar = filterValue.car !== "";
		const isShowMoveCarButton = filterValue.car !== "" && filterValue.time != "0";
		var content;
		if (timeSpeed === 600) {
			content = <IcGPSTimeX1 />;
		} else if (timeSpeed === 300) {
			content = <IcGPSTimeX2 />;
		} else if (timeSpeed === 200) {
			content = <IcGPSTimeX3 />;
		} else if (timeSpeed === 150) {
			content = <IcGPSTimeX4 />;
		}
		return (
			<React.Fragment>
				<div
					ref="map"
					className={`map-container ${isOneCar && !isSettingAreaLimit ? "tracking-car" : ""} ${
						isSettingAreaLimit && addPointMode ? "add-marker" : ""
					}`}
				/>
				{isShowMoveCarButton && !isSettingAreaLimit && (
					<div className="audio-player-container">
						{pastPointCount === pastPointMarkers.length - 1 ? (
							<div onClick={returnMoveCar}>
								<IcGPSReturn />
							</div>
						) : isPlay ? (
							<div
								onClick={() => {
									handlePauseCar();
								}}>
								<IcGPSPause />
							</div>
						) : (
							<div
								onClick={() => {
									startMoveCar();
									handlePlayCar();
								}}>
								<IcGPSPlay />
							</div>
						)}
						<div className="range-slider">
							<ReactSimpleRange
								step={1}
								min={0}
								max={pastPointMarkers.length - 1}
								value={pastPointCount}
								sliderSize={6}
								thumbSize={12}
								trackColor={"#00a550"}
								thumbColor={"#141414"}
								onChangeComplete={onPlayerTrackingDraggableChange}
							/>
						</div>
						<div
							onClick={() => {
								changeTimeSpeed();
							}}>
							{content}
						</div>
						{pastPointMarkers.length > 0 && (
							<span className="time">{moment(pastPointMarkers[pastPointCount].ts).format("LT")}</span>
						)}
					</div>
				)}
			</React.Fragment>
		);
	}
}

class GPSFilter extends React.Component {
	constructor(props) {
		super(props);
	}

	resetFilter = () => {
		this.props.resetFilter();
		this.props.toggleFilter();
	};

	setFilter = (event) => {
		const { name, value } = event.target;
		this.props.setFilter({
			...this.props.filterValue,
			time: "0",
			[name]: value,
		});
		this.props.toggleFilter();
	};

	render() {
		const { allCars, filterValue } = this.props;
		const hasFilter = filterValue.car !== "";
		return (
			<div className="modal-input-body">
				<div className="line-form">
					<div className="custom-input">
						<div className="wrap-info">
							<div className="title-status">
								<p className="font-14">Xe</p>
							</div>
						</div>
						<div className="custom-select">
							<select name="car" onChange={this.setFilter} value={filterValue.car}>
								<option key="" value="">
									Tất cả
								</option>
								{allCars &&
									allCars.map((car) => (
										<option key={car.id} value={car.id}>
											{car.name + " | " + car.licensePlate}
										</option>
									))}
							</select>
						</div>
					</div>
				</div>
				<div className="wrap-btn">
					<a className={`btn btn-reset btn-second ${hasFilter ? "has-dot-red" : ""}`} onClick={this.resetFilter}>
						Bỏ lọc
					</a>
				</div>
			</div>
		);
	}
}
class GPSSetting extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.getAllSetting(this.props.cars[0].id);
	}

	render() {
		const {
			cars,
			markers,
			enableMaxSpeed,
			maxSpeed,
			notiOverMaxSpeed,
			toggleEnableMaxSpeed,
			toggleNotiOverMaxSpeed,
			onMaxSpeedChange,
			enableAreaLimit,
			areaLimit,
			notiOutOfAreaLimit,
			toggleEnableAreaLimit,
			toggleNotiOutOfAreaLimit,
			removeAreaLimit,
			addAreaLimit,
			toggleSettingAreaLimit,
			toggleGPSSetting,
			updateGPSDeviceConfigInfo,
			turnOnBounds,
		} = this.props;
		return (
			<React.Fragment>
				<div className="modal-special-body">
					<div className="d-flex-center-btw">
						<p className="fontWeight-7">GIỚI HẠN VẬN TỐC</p>
						<div className="custom-switch">
							<input id="cb-maxSpeed" type="checkbox" checked={enableMaxSpeed} onChange={toggleEnableMaxSpeed} />
							<label htmlFor="cb-maxSpeed" />
						</div>
					</div>
					{enableMaxSpeed && (
						<React.Fragment>
							<div className="d-flex-center-btw">
								<p>Vận tốc tối đa (km/h)</p>
								<div className="custom-input">
									<div className="wrap-input">
										<input className="textAlign-center" type="number" onChange={onMaxSpeedChange} value={maxSpeed} />
									</div>
								</div>
							</div>
							<div className="custom-checkbox-selected">
								<input
									id="cb-notiMaxSpeed"
									type="checkbox"
									checked={notiOverMaxSpeed}
									onChange={toggleNotiOverMaxSpeed}
								/>
								<label className="font-14" htmlFor="cb-notiMaxSpeed">
									Thông báo cho tôi khi xe vượt quá tốc độ
								</label>
							</div>
						</React.Fragment>
					)}
					<div className="space" />
					<p className="fontWeight-7">GIỚI HẠN VÙNG DI CHUYỂN</p>
					<div className="d-flex-center-btw">
						<p className="fontWeight-7">Khoanh vùng giới hạn</p>
						<div className="custom-switch">
							<input id="cb-areaLimit" type="checkbox" checked={enableAreaLimit} onChange={toggleEnableAreaLimit} />
							<label htmlFor="cb-areaLimit" />
						</div>
					</div>
					{enableAreaLimit && (
						<React.Fragment>
							<p className="text-note">Chọn tối đa 10 điểm trên bản đồ để tạo vùng giới hạn</p>
							{areaLimit.length === 0 ? (
								<p
									className="text-success"
									onClick={() => {
										addAreaLimit(markers[cars[0].id]);
										toggleSettingAreaLimit();
										toggleGPSSetting();
									}}>
									+ Thêm vùng giới hạn
								</p>
							) : (
								<div className="limit-place">
									<p className="limit">Vùng giới hạn</p>
									<div className="limit-icon">
										<a
											onClick={() => {
												toggleSettingAreaLimit();
												toggleGPSSetting();
											}}>
											<IcMap />
										</a>
										<div className="line-limit" />
										<a onClick={removeAreaLimit}>
											<IcGarbage />
										</a>
									</div>
								</div>
							)}
							<div className="custom-checkbox-selected">
								<input
									id="cb-notiOutOfAreaLimit"
									type="checkbox"
									checked={notiOutOfAreaLimit}
									onChange={toggleNotiOutOfAreaLimit}
								/>
								<label className="font-14" htmlFor="cb-notiOutOfAreaLimit">
									Thông báo cho tôi khi xe ra khỏi thành&nbsp;phố
								</label>
							</div>
						</React.Fragment>
					)}
					<div className="wrap-btn">
						<a
							className="btn btn--m btn-primary"
							onClick={() => {
								updateGPSDeviceConfigInfo();
								toggleGPSSetting();
							}}>
							Lưu
						</a>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

class SwiperTimes extends React.Component {
	constructor(props) {
		super(props);
	}

	resetFilter = () => {
		this.props.resetFilter();
	};

	setFilter = (event) => {
		this.props.setFilter({
			...this.props.filterValue,
			time: event.target.getAttribute("data-value"),
		});
	};

	componentDidMount() {
		this.swiper = new window.Swiper(this.refs.swiper, {
			slidesPerView: "auto",
			spaceBetween: 15,
			direction: "horizontal",
			threshold: 15,
			speed: 600,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
		});
	}

	renderTime = (date) => {
		if (date * 1000 === moment().startOf("day").valueOf()) {
			return "Hôm nay";
		} else if (date * 1000 === moment().subtract(1, "days").startOf("day").valueOf()) {
			return "Hôm qua";
		} else {
			return moment(date * 1000).format("L");
		}
	};

	render() {
		const { filterValue, dates } = this.props;
		return (
			<div className="time-container">
				<div className="swiper swiper-times" ref="swiper">
					<div className="swiper-wrapper" name="time">
						<div
							className={`swiper-slide ${filterValue.time === "0" ? "active" : ""}`}
							onClick={(e) => {
								this.setFilter(e);
							}}
							data-value="0">
							Hiện tại
						</div>
						<div
							className={`swiper-slide ${filterValue.time === "900" ? "active" : ""}`}
							onClick={(e) => {
								this.setFilter(e);
							}}
							data-value="900">
							15 phút trước
						</div>
						<div
							className={`swiper-slide ${filterValue.time === "1800" ? "active" : ""}`}
							onClick={(e) => {
								this.setFilter(e);
							}}
							data-value="1800">
							30 phút trước
						</div>
						<div
							className={`swiper-slide ${filterValue.time === "3600" ? "active" : ""}`}
							onClick={(e) => {
								this.setFilter(e);
							}}
							data-value="3600">
							1 tiếng trước
						</div>
						{dates &&
							dates
								.map((date, i) => (
									<div
										className={`swiper-slide ${filterValue.time == date ? "active swiper-slide-active" : ""}`}
										onClick={(e) => {
											this.setFilter(e);
										}}
										data-value={date}
										key={date}>
										{this.renderTime(date)}
									</div>
								))
								.reverse()}
					</div>
				</div>
			</div>
		);
	}
}

class DetailsTripGPS extends React.Component {
	constructor() {
		super();
	}

	getDetailsTripGPS = (carId, pos) => {
		this.props.getDetailsTripGPS(carId, pos);
	};

	setFilter = (time) => {
		if (this.props.dates.includes(moment(time).startOf("date").valueOf() / 1000)) {
			this.props.setFilter({
				...this.props.filterValue,
				time: moment(time).startOf("date").valueOf() / 1000,
			});
		}
	};

	setPastPointCountActivities = (activity) => {
		setTimeout(() => {
			const timeArr = this.props.pastPointMarkers.map((pastPointMarker) => pastPointMarker.ts);

			//Find the index of closet value
			const diffArr = timeArr.map((x) => Math.abs(activity.time - x));
			const minNumber = Math.min(...diffArr);
			const index = diffArr.findIndex((x) => x === minNumber);

			this.props.onPlayerTrackingChange(index);
			if (index !== -1) {
				this.props.startMoveCar();
				this.props.handlePlayCar();
				this.props.handlePauseCar();
				this.props.turnOnBounds();
				this.props.turnOffBounds();
			}
		}, 500);
	};

	renderTime = (date) => {
		if (date === moment().format("L")) {
			return "Hôm nay";
		} else if (date === moment().subtract(1, "days").format("L")) {
			return "Hôm qua";
		} else {
			return date;
		}
	};

	render() {
		const {
			activities,
			more,
			cars,
			activitiesRaw,
			showTitle,
			toggleDetailsTripGPS,
			isOpenDetailsTripGPS,
			refreshDetailsTrip,
			turnOnBounds,
		} = this.props;
		if (Object.keys(activities).length > 0) {
			const datesKey = Object.keys(activities);
			const datesValue = Object.values(activities);
			return (
				<div className={`left-table-container ${!showTitle ? "left-modal" : ""}`}>
					{showTitle && (
						<div className="left-table-close">
							<div
								className="close"
								onClick={() => {
									refreshDetailsTrip(cars);
								}}>
								<IcRefresh />
							</div>
						</div>
					)}
					<InfiniteScroll
						pageStart={0}
						loadMore={() => {
							this.getDetailsTripGPS(cars[0].id, activitiesRaw.length);
						}}
						hasMore={more === 1}
						loader={<LoadingInlineSmall key={0} />}
						useWindow={false}>
						<div className="left-table-body">
							{showTitle && <h4 className="n-title">CHI TIẾT HÀNH TRÌNH</h4>}
							{datesKey &&
								datesKey.map((dk) => (
									<React.Fragment key={dk}>
										<h5>{this.renderTime(dk)}</h5>
										<div className="detail-tracking-item">
											{datesValue &&
												datesValue.map((dv, idx) => (
													<React.Fragment key={idx}>
														{dv
															.filter((dvc) => moment(dvc.time).format("L") == dk)
															.map((dvc, idx) => (
																<div
																	className="step"
																	key={idx}
																	onClick={() => {
																		this.setFilter(dvc.time);
																		this.setPastPointCountActivities(dvc);
																		{
																			isOpenDetailsTripGPS && toggleDetailsTripGPS();
																		}
																	}}>
																	<div className="time">
																		<p className="left">{moment(dvc.time).format("LT")}</p>
																		<div className={`line-dot ${getDetailGPSStatus(dvc.title).class}`} />
																		<div className="right">
																			<h6>{dvc.title}</h6>
																		</div>
																	</div>
																	{/* 
                                        <div className="address">
                                        <IcLocation18 />
                                        <p>{dvc.address}</p>
                                        </div>
*/}
																</div>
															))}
													</React.Fragment>
												))}
										</div>
									</React.Fragment>
								))}
						</div>
					</InfiniteScroll>
				</div>
			);
		} else {
			return (
				<div className="left-table-container">
					<div className="left-table-body">
						{showTitle && <h4 className="n-title">CHI TIẾT HÀNH TRÌNH</h4>}
						<LoadingInline />
					</div>
				</div>
			);
		}
	}
}

class DetailsTracking extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { cars, markers, activitiesRaw, enableMaxSpeed, maxSpeed } = this.props;
		const carId = cars[0].id;
		const marker = markers[carId];
		const { speed, height, batteryPercentage, currentActivity, address, ts, lat, lng, activeTime } = marker;

		let batteryColor;
		let batteryClassName;
		let batteryLabel;
		if (batteryPercentage >= 50) {
			batteryColor = <IcBatteryGreen />;
			batteryClassName = "";
			batteryLabel = "Tốt";
		} else if (batteryPercentage < 50 && batteryPercentage >= 15) {
			batteryColor = <IcBatteryYellow />;
			batteryClassName = "";
			batteryLabel = "Khá";
		} else {
			batteryColor = <IcBatteryRed />;
			batteryClassName = "text-danger";
			batteryLabel = "Yếu";
		}

		let speedStatus;
		let speedClassName;
		if (enableMaxSpeed && speed > maxSpeed) {
			speedStatus = <IcSpeedRed />;
			speedClassName = "text-danger";
		} else {
			speedStatus = <IcSpeed />;
			speedClassName = "";
		}

		return (
			<div className="detail-tracking">
				<div className="parameter">
					<div className="parameter-item">
						{speedStatus}
						<div className="d-flex">
							<p className="info">Vận tốc</p>
							<p className={`desc ${speedClassName}`}>{speed.toFixed(1)} km/h</p>
						</div>
					</div>
					<div className="line-vertical"></div>
					<div className="parameter-item">
						<IcHigher />
						<div className="d-flex">
							<p className="info">Độ cao</p>
							<p className="desc">{height} m</p>
						</div>
					</div>
					{batteryPercentage !== 0 && (
						<React.Fragment>
							<div className="line-vertical"></div>
							<div className="parameter-item">
								{batteryColor}
								<div className="d-flex">
									<p className="info">Mức pin</p>
									<p className={`desc ${batteryClassName}`}>{batteryLabel}</p>
								</div>
							</div>
						</React.Fragment>
					)}
				</div>
				<div className="line"> </div>
				<div className="move-car">
					<span className={`status ${getDetailGPSStatus(currentActivity).class}`}> </span>
					{currentActivity}
				</div>
				{address !== "" ? (
					<div className="address">
						<div className="wrap-svg">
							<IcBCrLocation />
						</div>
						{address}
					</div>
				) : (
					<a className="address" href={`https://www.google.com/maps/place/${lat},${lng}`} target="_blank">
						<div className="wrap-svg">
							<IcBCrLocation />
						</div>
						{`Không lấy được địa chỉ, Toạ độ: ${lat},${lng}`}
					</a>
				)}
				{/* <div className="note">
					<div className="note-item">
						<IcWarning />
						Đang di chuyển ngoài vùng giới hạn
					</div>
					<div className="note-item">
						<IcWarning />
						Đang di chuyển quá tốc độ
					</div>
				</div> */}
				<div className="line"> </div>
				{moment().valueOf() - activeTime < 3600000 ? (
					<p className="updatedAt">Vừa cập nhật</p>
				) : (
					<p className="updatedAt">Cập nhật {moment(activeTime).fromNow()}</p>
				)}
			</div>
		);
	}
}

export default class CarsGPS extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			isUpdateBounds: true,
			isOpenFilter: false,
			filterValue: {
				car: "",
				time: "0",
			},
			activities: [],
			activitiesRaw: [],
			more: "",
			enableMaxSpeed: false,
			maxSpeed: 0,
			notiOverMaxSpeed: false,
			enableAreaLimit: false,
			areaLimit: [],
			notiOutOfAreaLimit: false,
			isSettingAreaLimit: false,
			pastPointMarkers: [],
			pastPointCount: 0,
			isMoveCar: false,
			isPlay: false,
			timeSpeed: 600,
			idInterval: [0],
			addPointMode: true,
			pPopupPastArr: [],
		};
	}

	//x1, x2, x3, x4, x8
	// timeSpeedArr = [840, 420, 315, 210, 105]
	timeSpeedArr = [600, 300, 200, 150];

	indexNumber = 1;

	changeTimeSpeed = () => {
		this.setState({
			timeSpeed: this.timeSpeedArr[this.indexNumber++],
		});
		if (this.indexNumber === this.timeSpeedArr.length) {
			this.indexNumber = 0;
		}
	};

	pushPopupPastArr = (pPopupPast) => {
		this.setState({
			pPopupPastArr: [...this.state.pPopupPastArr, pPopupPast],
		});
	};

	componentDidMount = () => {
		getOwnerCars(0, 0, 0, 0, true).then((resp) => {
			if (resp.data.data && resp.data.data.cars) {
				const { cars } = resp.data.data;
				this.getCarsLocation(cars, true /*update bounds of map at first time*/, null, true);
			} else {
				this.setState({
					err: commonErr.FAIL,
				});
			}
		});

		window.addEventListener("resize", this.updateDimensions);
		this.checkWidthWindow();
	};

	checkWidthWindow = () => {
		if (window.innerWidth <= 576) {
			this.setState({
				invalidWidth: true,
			});
		} else {
			this.setState({
				invalidWidth: false,
			});
		}
	};

	updateDimensions = () => {
		this.checkWidthWindow();
	};

	getAllSetting = (carId) => {
		getCarsLocation(carId).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.carLocs[0].setting) {
				this.setState({
					enableMaxSpeed: !!resp.data.data.carLocs[0].setting.enableMaxSpeed,
					maxSpeed: resp.data.data.carLocs[0].setting.maxSpeed || 0,
					notiOverMaxSpeed: !!resp.data.data.carLocs[0].setting.notiOverMaxSpeed,
					enableAreaLimit: !!resp.data.data.carLocs[0].setting.enableAreaLimit,
					areaLimit: resp.data.data.carLocs[0].setting.areaLimit || [],
					notiOutOfAreaLimit: !!resp.data.data.carLocs[0].setting.notiOutOfAreaLimit,
				});
			} else {
				this.setState({
					enableAreaLimit: false,
					areaLimit: [],
					notiOutOfAreaLimit: false,
					enableMaxSpeed: false,
					maxSpeed: 0,
					notiOverMaxSpeed: false,
				});
			}
		});
	};

	getCarLocationHistory(cars, count, last, dateInSeconds) {
		const carIds = cars.map((car) => car.id).join(";");
		getCarLocationHistory(carIds, count, last, dateInSeconds).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.loc) {
				const pastPointMarkers = [];
				const markers = [];
				const { lat, lon, ts, speed, gps } = resp.data.data.loc || 0;
				if (gps !== null) {
					for (let i = 1; i < ts.length - 2; i++) {
						if (lat[i] !== lat[i - 1] && lon[i] !== lon[i - 1] && (lat[i - 1] !== 0 || lon[i - 1] !== 0)) {
							pastPointMarkers.push({
								ts: ts[i] * 1000,
								lat: lat[i],
								lng: lon[i],
								preLat: lat[i - 1],
								preLng: lon[i - 1],
								speed: speed[i],
								preSpeed: speed[i - 1],
							});
						}
					}
					markers[carIds] = {
						car: cars[0],
						ts: ts[ts.length - 1] * 1000,
						lat: lat[ts.length - 1],
						lng: lon[ts.length - 1],
						preLat: lat[ts.length - 2],
						preLng: lon[ts.length - 2],
						speed: speed[ts.length - 1],
						preSpeed: speed[ts.length - 2],
					};
				}
				this.setState({
					err: commonErr.SUCCESS,
					pastPointMarkers,
					markers,
				});
			} else {
				this.setState({
					err: commonErr.FAIL,
				});
			}
		});
	}

	toggleBounds = () => {
		this.setState({
			isUpdateBounds: !this.state.isUpdateBounds,
		});
	};

	turnOnBounds = () => {
		this.setState({
			isUpdateBounds: true,
		});
	};

	turnOffBounds = () => {
		this.setState({
			isUpdateBounds: false,
		});
	};

	getIdInterval = (id) => {
		this.setState({
			idInterval: [...this.state.idInterval, id],
		});
	};

	getCarsLocation = (cars, isUpdateBounds, maxTimeInSeconds, firstFlag) => {
		const carIds = cars.map((car) => car.id).join(";");
		const count = maxTimeInSeconds ? (maxTimeInSeconds === "900" ? 1000 : 2000) : MAX_LAT_LNG_PER_TIME;
		getCarsLocation(carIds, count, maxTimeInSeconds).then(async (carsLocationResp) => {
			if (
				carsLocationResp.data.error >= commonErr.SUCCESS &&
				carsLocationResp.data.data.carLocs &&
				carsLocationResp.data.data.carLocs.length > 0
			) {
				const markers = [];
				const pastPointMarkers = [];
				const validGPSCars = [];

				// convert to milliseconds
				const dates = carsLocationResp.data.data.dates.map((date) => date);

				for (let carLoc of carsLocationResp.data.data.carLocs) {
					const validGPSCar = cars.filter((car) => car.id === carLoc.carId)[0];
					validGPSCars.push(validGPSCar);
					const { lat, lon, ts, speed } = carLoc.loc || 0;
					const { height, batteryPercentage, currentActivity } = carLoc.status || 0;
					const { address, activeTime } = carLoc;
					if (carLoc.loc.gps !== null) {
						const l = ts.length;

						try {
							// Map4d:
							// const result = await getAddressFromLatLng(lat[l - 1], lon[l - 1]);
							// const address = result.data.result ? result.data.result[0].address : "";

							// const result = await getAddressFromLatLngHere(lat[l - 1], lon[l - 1]);
							// const address = result.data.items.length ? result.data.items[0].address.label : "";

							markers[carLoc.carId] = {
								car: validGPSCar,
								ts: ts[l - 1] * 1000,
								lat: lat[l - 1],
								lng: lon[l - 1],
								preLat: lat[l - 2],
								preLng: lon[l - 2],
								speed: speed[l - 1],
								preSpeed: speed[l - 2],
								address: address,
								height: height ? height : 0,
								batteryPercentage: batteryPercentage ? batteryPercentage : 0,
								currentActivity: currentActivity ? currentActivity : "Không thể xác định",
								activeTime: activeTime,
							};
						} catch (e) {}

						for (var i = 1; i < l - 2; i++) {
							// remove default lat, lon  === 0, duplicate
							if (lat[i] !== lat[i - 1] && lon[i] !== lon[i - 1] && (lat[i - 1] !== 0 || lon[i - 1] !== 0)) {
								pastPointMarkers.push({
									ts: ts[i] * 1000,
									lat: lat[i],
									lng: lon[i],
									preLat: lat[i - 1],
									preLng: lon[i - 1],
									speed: speed[i],
									preSpeed: speed[i - 1],
								});
							}
						}
					} else {
						try {
							const result = await getCarsLocation(carIds, 2, null);
							const loc = result.data.data.carLocs[0].loc;
							markers[carLoc.carId] = {
								address: null,
								car: validGPSCar,
								lat: loc.lat[1],
								lng: loc.lon[1],
								preLat: loc.lat[0],
								preLng: loc.lon[0],
								speed: loc.speed[1],
								preSpeed: loc.speed[0],
								height: height ? height : 0,
								batteryPercentage: batteryPercentage ? batteryPercentage : 0,
								currentActivity: currentActivity ? currentActivity : "Không thể xác định",
							};
						} catch (e) {}
					}
				}
				this.setState({
					err: commonErr.SUCCESS,
					isUpdateBounds,
					markers,
					dates,
					cars: validGPSCars,
					allCars: firstFlag ? validGPSCars : this.state.allCars,
					pastPointMarkers,
					maxTimeInSeconds,
				});
				if (this.state.allCars.length === 1) {
					if (firstFlag) {
						this.getDetailsTripGPS(this.state.allCars[0].id, 0);
					}
					this.getAllSetting(this.state.allCars[0].id);
					this.setState({
						filterValue: {
							...this.state.filterValue,
							car: validGPSCars[0].id,
						},
					});
				}
			} else {
				this.setState({
					err: commonErr.FAIL,
				});
			}
		});
	};

	getDetailsTripGPS = (carId, pos) => {
		getDetailsTripGPS(carId, pos).then(async (resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.activities && resp.data.data.activities.length > 0) {
				try {
					setTimeout(async () => {
						const getData = resp.data.data.activities;
						const dataFilter = getData.filter((data) => data.lat !== 0 && data.lon !== 0);
						const activitiesRaw = await Promise.all(
							dataFilter.map(async (item) => {
								if (item.lat !== 0 && item.lon !== 0) {
									// const result = await getAddressFromLatLng(item.lat, item.lon);
									// const address = result.data.items[0].address.label;
									return {
										...item,
										// address: address,
									};
								}
							})
						);
						this.setState({
							activitiesRaw: this.state.activitiesRaw.concat(activitiesRaw),
							activities: _.groupBy(this.state.activitiesRaw.concat(activitiesRaw), ({ time }) =>
								moment(time).format("L")
							),
							more: resp.data.data.more,
							err: resp.data.error,
						});
					}, 500);
				} catch (e) {}
			} else {
				this.setState({
					// err: resp.data.error,
					more: 0,
				});
			}
		});
	};

	// <- Filter
	toggleFilter = () => {
		this.setState({
			isOpenFilter: !this.state.isOpenFilter,
		});
	};

	setFilter = (filterValue) => {
		const { allCars } = this.state;
		this.setState({
			filterValue,
		});
		if (filterValue.car === "") {
			for (let i = 0; i < this.state.idInterval.length; ++i) {
				clearInterval(this.state.idInterval[i]);
			}
			for (let i = 0; i < this.state.pPopupPastArr.length; ++i) {
				this.state.pPopupPastArr[i].setMap(null);
			}
			this.setState({
				activities: [],
				activitiesRaw: [],
				areaLimit: [],
				pastPointCount: 0,
			});
			this.endMoveCar();
			this.handlePauseCar();
			this.getCarsLocation(allCars, true);
		} else {
			// 1 car
			if (filterValue.time === "0") {
				for (let i = 0; i < this.state.idInterval.length; ++i) {
					clearInterval(this.state.idInterval[i]);
				}
				for (let i = 0; i < this.state.pPopupPastArr.length; ++i) {
					this.state.pPopupPastArr[i].setMap(null);
				}
				this.setState({
					activities: [],
					activitiesRaw: [],
					pastPointCount: 0,
				});
				const cars = allCars.filter((car) => car.id === filterValue.car);
				this.endMoveCar();
				this.handlePauseCar();
				this.getCarsLocation(cars, true);
				this.getDetailsTripGPS(cars[0].id, 0);
				this.getAllSetting(cars[0].id);
			} else if (filterValue.time > 0 && filterValue.time <= 3600) {
				for (let i = 0; i < this.state.idInterval.length; ++i) {
					clearInterval(this.state.idInterval[i]);
				}
				for (let i = 0; i < this.state.pPopupPastArr.length; ++i) {
					this.state.pPopupPastArr[i].setMap(null);
				}
				this.setState({
					pastPointCount: 0,
				});
				const cars = allCars.filter((car) => car.id === filterValue.car);
				this.endMoveCar();
				this.handlePauseCar();
				this.getCarsLocation(cars, true, filterValue.time);
				setTimeout(() => {
					this.turnOffBounds();
				}, 500);
			} else if (filterValue.time > 3600) {
				for (let i = 0; i < this.state.idInterval.length; ++i) {
					clearInterval(this.state.idInterval[i]);
				}
				for (let i = 0; i < this.state.pPopupPastArr.length; ++i) {
					this.state.pPopupPastArr[i].setMap(null);
				}
				this.setState({
					pastPointCount: 0,
				});
				const cars = allCars.filter((car) => car.id === filterValue.car);
				this.endMoveCar();
				this.handlePauseCar();
				this.turnOnBounds();
				this.getCarLocationHistory(cars, 2, true, filterValue.time);
				setTimeout(() => {
					this.turnOffBounds();
				}, 500);
			}
		}
	};

	resetFilter = () => {
		const { allCars } = this.state;
		for (let i = 0; i < this.state.idInterval.length; ++i) {
			clearInterval(this.state.idInterval[i]);
		}
		for (let i = 0; i < this.state.pPopupPastArr.length; ++i) {
			this.state.pPopupPastArr[i].setMap(null);
		}
		this.endMoveCar();
		this.handlePauseCar();
		this.setState({
			activities: [],
			activitiesRaw: [],
			areaLimit: [],
			filterValue: {
				car: "",
				time: "0",
			},
			pastPointCount: 0,
		});
		this.getCarsLocation(allCars, true);
	};
	// -> Filter when click icon car
	filterWhenClickIcon = (carId) => {
		this.setState({
			filterValue: {
				time: "0",
				car: carId,
			},
		});
	};

	//Refresh Details Trip
	refreshDetailsTrip = (cars) => {
		this.setState({
			activities: [],
			activitiesRaw: [],
		});
		this.getDetailsTripGPS(cars[0].id, 0);
	};

	//GPS Setting
	toggleGPSSetting = () => {
		this.setState({
			isOpenGPSSetting: !this.state.isOpenGPSSetting,
		});
	};

	toggleDetailsTracking = () => {
		this.setState({
			isOpenDetailsTracking: !this.state.isOpenDetailsTracking,
		});
	};

	toggleDetailsTripGPS = () => {
		this.setState({
			isOpenDetailsTripGPS: !this.state.isOpenDetailsTripGPS,
		});
	};

	//Input Range Onchange
	onPlayerTrackingChange = (j) => {
		this.setState({
			pastPointCount: j,
		});
	};

	onPlayerTrackingDraggableChange = (range) => {
		this.setState({
			pastPointCount: parseFloat(range.value),
		});
	};

	returnMoveCar = () => {
		this.setState({
			pastPointCount: 0,
		});
		this.startMoveCar();
		this.handlePlayCar();
		setTimeout(() => {
			this.turnOnBounds();
			this.turnOffBounds();
		}, 500);
	};

	startMoveCar = () => {
		this.setState({
			isMoveCar: true,
		});
	};

	endMoveCar = () => {
		this.setState({
			isMoveCar: false,
		});
	};

	handlePlayCar = () => {
		this.setState({
			isPlay: true,
		});
	};

	handlePauseCar = () => {
		this.setState({
			isPlay: false,
		});
	};

	setMarkerInPastPointMarker = (pastPointMarker, cars) => {
		const markers = [];
		markers[cars[0].id] = {
			car: cars[0],
			ts: pastPointMarker.ts,
			lat: pastPointMarker.lat,
			lng: pastPointMarker.lng,
			preLat: pastPointMarker.preLat,
			preLng: pastPointMarker.preLng,
			speed: pastPointMarker.speed,
			preSpeed: pastPointMarker.preSpeed,
		};
		this.setState({
			markers,
		});
	};
	// -> MoveCar

	//setting Area Limit

	toggleEnableMaxSpeed = () => {
		this.setState({
			enableMaxSpeed: !this.state.enableMaxSpeed,
		});
	};

	toggleNotiOverMaxSpeed = () => {
		this.setState({
			notiOverMaxSpeed: !this.state.notiOverMaxSpeed,
		});
	};

	onMaxSpeedChange = (event) => {
		if (isNaN(event.target.value)) {
			return;
		}
		this.setState({
			maxSpeed: event.target.value,
		});
	};

	toggleEnableAreaLimit = () => {
		this.setState({
			enableAreaLimit: !this.state.enableAreaLimit,
		});
	};

	toggleNotiOutOfAreaLimit = () => {
		this.setState({
			notiOutOfAreaLimit: !this.state.notiOutOfAreaLimit,
		});
	};

	removeAreaLimit = () => {
		this.setState({
			areaLimit: [],
		});
	};

	toggleSettingAreaLimit = () => {
		this.setState({
			isSettingAreaLimit: !this.state.isSettingAreaLimit,
		});
	};

	addMode = () => {
		this.setState({
			addPointMode: true,
		});
	};

	deleteMode = () => {
		this.setState({
			addPointMode: false,
		});
	};

	//Car has no AreaLimit
	addAreaLimit = (markers) => {
		this.setState({
			areaLimit: [
				{
					lat: markers.lat + 0.02,
					lon: markers.lng,
				},
				{
					lat: markers.lat,
					lon: markers.lng + 0.02,
				},
				{
					lat: markers.lat - 0.02,
					lon: markers.lng,
				},
				{
					lat: markers.lat,
					lon: markers.lng - 0.02,
				},
			],
		});
	};

	getAreaLimitPost = (areaLimitPost) => {
		this.setState({
			areaLimit: areaLimitPost,
		});
	};

	//Post Data to Server
	updateGPSDeviceConfigInfo = () => {
		const pEnableMaxSpeed = this.state.enableMaxSpeed;
		const pMaxSpeed = this.state.maxSpeed;
		const pNotiOverMaxSpeed = this.state.notiOverMaxSpeed;

		const pEnableAreaLimit = this.state.enableAreaLimit;
		const pAreaLimit = this.state.areaLimit.map((x) => x.lat + "-" + x.lon).join(";");
		const pNotiOutOfAreaLimit = this.state.notiOutOfAreaLimit;
		updateGPSDeviceConfig(
			this.state.cars[0].id,
			pEnableMaxSpeed,
			pMaxSpeed,
			pNotiOverMaxSpeed,
			0,
			0,
			0,
			pEnableAreaLimit,
			pAreaLimit,
			pNotiOutOfAreaLimit
		);
	};

	render() {
		const {
			pPopupPastArr,
			addPointMode,
			err,
			cars,
			markers,
			isUpdateBounds,
			filterValue,
			dates,
			activities,
			activitiesRaw,
			more,
			enableMaxSpeed,
			maxSpeed,
			notiOverMaxSpeed,
			enableAreaLimit,
			areaLimit,
			notiOutOfAreaLimit,
			isSettingAreaLimit,
			pastPointMarkers,
			maxTimeInSeconds,
			isOpenFilter,
			allCars,
			isOpenGPSSetting,
			isOpenDetailsTracking,
			isOpenDetailsTripGPS,
			isMoveCar,
			isPlay,
			pastPointCount,
			timeSpeed,
			idInterval,
		} = this.state;
		const isShowMoveCarButton = filterValue.car !== "" && filterValue.time != "0";
		const isOneCar = filterValue.car !== "";
		const hasFilter = filterValue.car !== "";
		const updateCars = filterValue.time == 0;
		var content;
		if (err === commonErr.INNIT) {
			content = <LoadingPage />;
		} else if (err <= commonErr.FAIL) {
			content = (
				<MessagePage
					message={
						<div>
							<div>Không tìm thấy dữ liệu hoặc bạn chưa có xe được tích hợp Mioto GPS</div>
							<div>
								(Tính năng mới trên Mioto, dành cho các chủ xe đã lắp đặt Mioto GPS. Liên hệ 19009271 để được tư vấn lắp
								đặt.)
							</div>
						</div>
					}
				/>
			);
		} else if (this.state.invalidWidth) {
			content = (
				<MessagePage
					message={
						<div>
							Tính năng chỉ hỗ trợ cho màn hình có kích thước lớn hơn 576px. Vui lòng xoay ngang màn hình hoặc sử dụng
							màn hình lớn hơn.
						</div>
					}
				/>
			);
		} else {
			var bodyContent = (
				<div className="tracking_cars--wrap" style={{ position: "relative" }}>
					{markers && (
						<CarMapLocation
							pushPopupPastArr={this.pushPopupPastArr}
							pPopupPastArr={pPopupPastArr}
							setMarkerInPastPointMarker={this.setMarkerInPastPointMarker}
							addPointMode={addPointMode}
							activitiesRaw={activitiesRaw}
							idInterval={idInterval}
							getIdInterval={this.getIdInterval}
							turnOnBounds={this.turnOnBounds}
							turnOffBounds={this.turnOffBounds}
							cars={cars}
							markers={markers}
							isUpdateBounds={isUpdateBounds}
							filterValue={filterValue}
							pastPointMarkers={pastPointMarkers}
							isMoveCar={isMoveCar}
							startMoveCar={this.startMoveCar}
							endMoveCar={this.endMoveCar}
							isPlay={isPlay}
							handlePlayCar={this.handlePlayCar}
							handlePauseCar={this.handlePauseCar}
							pastPointCount={pastPointCount}
							onPlayerTrackingChange={this.onPlayerTrackingChange}
							onPlayerTrackingDraggableChange={this.onPlayerTrackingDraggableChange}
							returnMoveCar={this.returnMoveCar}
							timeSpeed={timeSpeed}
							changeTimeSpeed={this.changeTimeSpeed}
							areaLimit={areaLimit}
							isSettingAreaLimit={isSettingAreaLimit}
							getAreaLimitPost={this.getAreaLimitPost}
							enableAreaLimit={enableAreaLimit}
							filterWhenClickIcon={this.filterWhenClickIcon}
							getDetailsTripGPS={this.getDetailsTripGPS}
							getAllSetting={this.getAllSetting}
							getCarsLocation={this.getCarsLocation}
						/>
					)}
					{updateCars && !isSettingAreaLimit && (
						<ReactInterval
							timeout={MIN_TIMER}
							enabled={true}
							callback={() =>
								this.getCarsLocation(cars, false /*DO NO update bounds of map when auto*/, maxTimeInSeconds, false)
							}
						/>
					)}
					<React.Fragment>
						{isSettingAreaLimit ? (
							<React.Fragment>
								<div className="optional-area">
									<span className={`point ${addPointMode ? "active" : ""}`} onClick={this.addMode}>
										THÊM ĐIỂM
									</span>
									<span className={`point ${addPointMode ? "" : "active"}`} onClick={this.deleteMode}>
										XÓA ĐIỂM
									</span>
								</div>
								<button
									className="btn btn--m btn-primary"
									onClick={() => {
										this.toggleSettingAreaLimit();
										this.updateGPSDeviceConfigInfo();
									}}>
									Lưu
								</button>
								<button
									className="btn btn--m btn-default btn-out"
									onClick={() => {
										this.toggleSettingAreaLimit();
										this.getAllSetting(cars[0].id);
									}}>
									Thoát
								</button>
							</React.Fragment>
						) : (
							allCars.length !== 1 && (
								<button
									className={`btn btn-primary btn--m btn-filter ${hasFilter ? "has-dot-red" : ""}`}
									onClick={this.toggleFilter}>
									<span>Chọn xe</span>
								</button>
							)
						)}

						{
							<div className={`icon-filter location ${isUpdateBounds && `active`}`} onClick={() => this.toggleBounds()}>
								<IcGPSFocus />
							</div>
						}
						{isOneCar && (
							<React.Fragment>
								{!isSettingAreaLimit && updateCars && (
									<div className={`icon-filter direct ${isOpenGPSSetting && `active`}`} onClick={this.toggleGPSSetting}>
										<IcGPSSetting />
									</div>
								)}

								{!isShowMoveCarButton && !isSettingAreaLimit && (
									<DetailsTracking
										enableMaxSpeed={enableMaxSpeed}
										maxSpeed={maxSpeed}
										cars={cars}
										markers={markers}
										activitiesRaw={activitiesRaw}
									/>
								)}
								{!isSettingAreaLimit && (
									<DetailsTripGPS
										turnOnBounds={this.turnOnBounds}
										turnOffBounds={this.turnOffBounds}
										startMoveCar={this.startMoveCar}
										handlePauseCar={this.handlePauseCar}
										handlePlayCar={this.handlePlayCar}
										refreshDetailsTrip={this.refreshDetailsTrip}
										onPlayerTrackingChange={this.onPlayerTrackingChange}
										pastPointMarkers={pastPointMarkers}
										showTitle={true}
										activities={activities}
										more={more}
										getDetailsTripGPS={this.getDetailsTripGPS}
										filterValue={filterValue}
										cars={cars}
										activitiesRaw={activitiesRaw}
										setFilter={this.setFilter}
										dates={dates}
									/>
								)}
								{isSettingAreaLimit ? (
									<div className="noti-limit">
										{addPointMode ? (
											<p>
												Thêm tối đa 10 điểm để tạo vùng giới hạn mong muốn. Chọn 1 điểm để kéo/thay đổi vùng giới hạn
											</p>
										) : (
											<p>
												Xóa các điểm đánh dấu để tạo vùng giới hạn mong muốn. Chọn 1 điểm để kéo/thay đổi vùng giới hạn
											</p>
										)}
									</div>
								) : (
									<SwiperTimes
										filterValue={filterValue}
										setFilter={this.setFilter}
										resetFilter={this.resetFilter}
										dates={dates}
									/>
								)}
								{!isShowMoveCarButton && !isSettingAreaLimit && (
									<div className="tab-mode show-on-lg">
										<div className="tab-box">
											<a onClick={this.toggleDetailsTripGPS} className="view-mode">
												Chi tiết hành trình
											</a>
											<a onClick={this.toggleDetailsTracking} className="view-mode">
												Thông tin hiện tại
											</a>
										</div>
									</div>
								)}
							</React.Fragment>
						)}
					</React.Fragment>
				</div>
			);

			content = <div className="content">{bodyContent}</div>;
		}
		return (
			<div className="mioto-layout bg-gray">
				<Header />
				<section className="body">{content}</section>
				<Modal show={isOpenFilter} onHide={this.toggleFilter} dialogClassName="modal-s modal-input">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Chọn xe</h5>
					</Modal.Header>
					<Modal.Body>
						<GPSFilter
							toggleFilter={this.toggleFilter}
							dates={dates}
							allCars={allCars}
							filterValue={filterValue}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
						/>
					</Modal.Body>
				</Modal>
				<Modal
					show={isOpenGPSSetting}
					onHide={(e) => {
						this.toggleGPSSetting();
						this.getAllSetting(cars[0].id);
					}}
					dialogClassName="modal-s modal-dialog modal-special">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Cài đặt</h5>
					</Modal.Header>
					<Modal.Body>
						<GPSSetting
							cars={cars}
							markers={markers}
							toggleGPSSetting={this.toggleGPSSetting}
							enableMaxSpeed={enableMaxSpeed}
							maxSpeed={maxSpeed}
							notiOverMaxSpeed={notiOverMaxSpeed}
							enableAreaLimit={enableAreaLimit}
							areaLimit={areaLimit}
							notiOutOfAreaLimit={notiOutOfAreaLimit}
							toggleEnableMaxSpeed={this.toggleEnableMaxSpeed}
							toggleNotiOverMaxSpeed={this.toggleNotiOverMaxSpeed}
							onMaxSpeedChange={this.onMaxSpeedChange}
							toggleEnableAreaLimit={this.toggleEnableAreaLimit}
							toggleNotiOutOfAreaLimit={this.toggleNotiOutOfAreaLimit}
							getAllSetting={this.getAllSetting}
							addAreaLimit={this.addAreaLimit}
							removeAreaLimit={this.removeAreaLimit}
							toggleSettingAreaLimit={this.toggleSettingAreaLimit}
							updateGPSDeviceConfigInfo={this.updateGPSDeviceConfigInfo}
							turnOnBounds={this.turnOnBounds}
						/>
					</Modal.Body>
				</Modal>
				<Modal
					show={isOpenDetailsTracking}
					onHide={this.toggleDetailsTracking}
					dialogClassName="modal-sm modal-dialog modal-detail-tracking">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>THÔNG TIN HIỆN TẠI</h5>
					</Modal.Header>
					<Modal.Body>
						<DetailsTracking
							enableMaxSpeed={enableMaxSpeed}
							maxSpeed={maxSpeed}
							cars={cars}
							markers={markers}
							activitiesRaw={activitiesRaw}
						/>
					</Modal.Body>
				</Modal>
				<Modal
					show={isOpenDetailsTripGPS}
					onHide={this.toggleDetailsTripGPS}
					dialogClassName="modal-sm modal-dialog modal-detail-tracking-item">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>CHI TIẾT HÀNH TRÌNH</h5>
					</Modal.Header>
					<Modal.Body>
						<DetailsTripGPS
							turnOnBounds={this.turnOnBounds}
							turnOffBounds={this.turnOffBounds}
							startMoveCar={this.startMoveCar}
							handlePauseCar={this.handlePauseCar}
							handlePlayCar={this.handlePlayCar}
							refreshDetailsTrip={this.refreshDetailsTrip}
							isOpenDetailsTripGPS={isOpenDetailsTripGPS}
							toggleDetailsTripGPS={this.toggleDetailsTripGPS}
							onPlayerTrackingChange={this.onPlayerTrackingChange}
							pastPointMarkers={pastPointMarkers}
							showTitle={false}
							activities={activities}
							more={more}
							getDetailsTripGPS={this.getDetailsTripGPS}
							filterValue={filterValue}
							cars={cars}
							activitiesRaw={activitiesRaw}
							setFilter={this.setFilter}
							dates={dates}
						/>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}
